import {storeToRefs} from 'pinia';
import {useInfosRequest} from '~/composables/useInfosRequest';
import type {UpdateHeaderSectionRequest} from '~/openapi';
import {ProfileEditionApi, Configuration} from '~/openapi';
import {useProfileStore} from '~/store/profileStore';
import {useSkillSetStore} from '~/store/skill-set/skillSetStore';

export const useProfileHeader = () => {
    const apiConfiguration = new Configuration({basePath: ''});
    const profileEditionApi = new ProfileEditionApi(apiConfiguration);

    const profileStoreRequest = useInfosRequest();
    const profileStore = useProfileStore();
    const {profile} = storeToRefs(profileStore);

    const skillSetStore = useSkillSetStore();

    async function updateProfileHeader(request: UpdateHeaderSectionRequest) {
        await profileEditionApi.updateHeaderSection({profileId: profile.value!.profileId, updateHeaderSectionRequest: request});

        await Promise.all([profileStore.getProfile(profileStoreRequest), skillSetStore.fetchSkillSet()]);
    }

    return {
        updateProfileHeader,
    };
};
